/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import { connect } from 'react-redux'
import React from 'react'
import { withRouter } from 'react-router'

import './FieldAppContainer.css'
import fieldapplogo from '../../../assets/img/field_app_view.png'
import ContainerWithMenu from './ContainerWithMenu'
import * as localForage from 'localforage'

import TRCButton from '../../../trace/TRCButton'
import { pageTitle } from 'trux'

class FieldAppPage extends ContainerWithMenu {
    constructor(props) {
        super(props, 'FieldApp', 'menu_field_app')
    }
    
    getMainCSSClass() {
        let alone = this.props.match.params.alone ? 'alone' : ''
        return `FieldApp ${alone}`
    }

    componentDidMount() {
        this.props.loadNav()
        pageTitle(this.getTitle(), "Settings - Field App")
    }

    getTitle() {
        return 'Ready to get started?'
    }

    isFromIOS() {
        return this.props.via === 'iosapp'
    }

    onClose() {
        if (this.props.match.params.alone) {
            this.onGoAdmin()
        } else {
            super.onClose()
        }
    }

    onBack() {
        if (this.props.match.params.alone) {
            this.onGoAdmin()
        } else {
            this.props.history.go(-1)
        }
    }

    hideBack() {
        return this.props.match.params.alone === 'alone' || this.props.match.params.alone === 'coach'
    }

    hideClose() {
        return this.props.match.params.alone === 'alone' || this.props.match.params.alone === 'coach'
    }



    get message() {
        var msg = 'You will need the Trace Teams app to trace your games.'
        if (this.props.match.params.editor) {
            msg = 'Trace Cam Games can only be edited on the Trace Teams App'
        }
        return msg
    }

    renderContent() {
        let alone = this.props.match.params.alone ? 'alone' : ''
        return (
            <div className={`FieldAppPage modal-container content ${alone}`}>
                <span>{this.message}</span>
                <img className="field-app-image" src={fieldapplogo} alt="field app img"/>
                <div className="bottom-buttons">
                    <TRCButton
                        onClick={() => this.onFieldAppIOS()}>
                        Download for iOS
                    </TRCButton>
                    {this.props.match.params.alone !== 'coach' && (
                        <TRCButton
                            ghost
                            onClick={() => this.onGoAdmin()}>
                            Continue to Team
                        </TRCButton>
                    )}
                </div>
            </div>
        )
    }

    onFieldAppIOS() {
        //this is a link to coach notes as we haven't release the field app yet
        window.location.href = 'https://itunes.apple.com/us/app/trace-teams/id1351001083'
    }

    onGoAdmin() {
        localForage.getItem('current_team_id').then(ctid => {
            var teamId = ctid
            if (!teamId || teamId === 'null' || teamId === 'undefined') {
                for (var d in this.props.navDivisions) {
                    var div = this.props.navDivisions[d]
                    if (div.teams.length > 0) {
                        teamId = div.teams[0].name
                        break
                    }
                }
            }
            this.props.history.replace(`/${teamId}`)
        })
    }
}

const mapStateToProps = (state, props) => {
    return {
        via: state.via,
        navDivisions: state.divisions.value ? state.divisions.value : [],
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadNav: () => {
        }
    }
}

const FieldAppContainer = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(FieldAppPage))

export default FieldAppContainer
